import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class CompetenciesApi {
  // ------ Competency Type API ------
  static getAllCompetencyTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.competencyTypeList, { params });
  }

  static getCompetencyType({ id }) {
    return axios.get(ApiEndpoints.competencyType.replace(':id:', id));
  }

  static createCompetencyType(params) {
    return axios.post(ApiEndpoints.competencyTypeList, params);
  }

  static updateCompetencyType(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.competencyType.replace(':id:', id), data);
  }

  static deleteCompetencyType({ id }) {
    return axios.delete(ApiEndpoints.competencyType.replace(':id:', id));
  }

  // ------ Competency API ------
  static getAllCompetencies(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.competenciesList, { params });
  }

  static getCompetency({ id }) {
    return axios.get(ApiEndpoints.competency.replace(':id:', id));
  }

  static createCompetency(params) {
    return axios.post(ApiEndpoints.competenciesList, params);
  }

  static updateCompetency(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.competency.replace(':id:', id), data);
  }

  static deleteCompetency({ id }) {
    return axios.delete(ApiEndpoints.competency.replace(':id:', id));
  }

  // ------ Competency Users Bulk Add/Remove API ------
  static getUnassignedUsersForCompetency(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.competencyUnassignedUsers, { params });
  }

  static getAssignedUsersForCompetency(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.competencyAssignedUsers, { params });
  }

  static addCompetencyToUsers(data) {
    const { id, params } = data;
    return axios.post(ApiEndpoints.competencyBulkAddUsers.replace(':id:', id), params);
  }

  static removeCompetencyFromUsers(data) {
    const { id, params } = data;
    return axios.post(ApiEndpoints.competencyBulkRemoveUsers.replace(':id:', id), params);
  }

  // ------ Competency Activities Bulk Add/Remove API ------
  static addCompetencyToActivities(data) {
    const { id, params } = data;
    return axios.post(ApiEndpoints.competencyBulkAddActivities.replace(':id:', id), params);
  }

  static removeCompetencyFromActivities(data) {
    const { id, params } = data;
    return axios.post(ApiEndpoints.competencyBulkRemoveActivities.replace(':id:', id), { activities: params });
  }

  // ------ Competency Validation API ------
  static checkCompetenciesValid(validationItems = []) {
    return axios.post(ApiEndpoints.competencyValidation, validationItems);
  }
}

export class UserCompetencyApi {
  static getAllUserCompetencies(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.userCompetencyList, { params });
  }

  static getUserCompetency({ id }) {
    return axios.get(ApiEndpoints.userCompetency.replace(':id:', id));
  }

  static createUserCompetency(params) {
    return axios.post(ApiEndpoints.userCompetencyList, params);
  }

  static updateUserCompetency(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.userCompetency.replace(':id:', id), data);
  }

  static deleteUserCompetency({ id }) {
    return axios.delete(ApiEndpoints.userCompetency.replace(':id:', id));
  }
}

export default CompetenciesApi;
